import { Component } from '@angular/core';
import { TituloModel, GrillaModel, FormBusquedaModel } from '../models/listapacientes.model';
import { PacientesService } from '../services/pacientes.service';


@Component({
// tslint:disable-next-line: component-selector
  selector: 'App-listapacientes',
  templateUrl: './../views/listapacientes.component.html',
  styleUrls: ['./../css/pacientes.component.css'],
  providers: [PacientesService]

})

export class ListaPacientesComponent {

  public pacientesTitle: TituloModel ;
  public formularioLabel: FormBusquedaModel;
  public grillaDatos: GrillaModel;
  public pacientes: any;
  public value: string;
  public buscando = false;
  public filtro: any;
  constructor(
    private _listaPacientesService: PacientesService
  ) {
    this.pacientesTitle =  new TituloModel('Buscar Pacientes');
    this.formularioLabel = new FormBusquedaModel('Ingrese nombre, apellido o rut del paciente');
    this.grillaDatos = new GrillaModel('Id Paciente','RUN Paciente', 'Nombre Paciente', 'Opciones');
    this.value = '';
    this.filtro = '';
  }

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
    this._listaPacientesService.getPacientes().subscribe(
      result => {
        this.pacientes = result.request;
        if (!this.pacientes) {
          console.log('no esta trayendo los pacientes');
        }
      },
      error => {
        let errorMensaje = error as any;
        console.log(errorMensaje);
      }

    );

  }
  muestraResultado(event: any) { // without type info
    if (event.target.value.length >= 3) {
      this.buscando = true;
    } else {
      this.buscando = false;
    }
  }

}
/*********************************************************************************************************************
 Construido y distribuido por IT-SolutionsSpa, soluciones informáticas para su negocio 
Santiago, Chile 2019,
Ingeniero de Software FrontEnd: Rodrigo Neira
Ingeniero de Software BackEnd: Octavio Cubillos
Gestor: Edison Núñez
mayor informacion a contacto@itsolutonsspa.cl
o en www.itsolutionsspa.cl 
 ********************************************************************************************************************/